import { render, staticRenderFns } from "./HowToProductLabels.vue?vue&type=template&id=2a433324&scoped=true"
import script from "./HowToProductLabels.vue?vue&type=script&lang=js"
export * from "./HowToProductLabels.vue?vue&type=script&lang=js"
import style0 from "./HowToProductLabels.vue?vue&type=style&index=0&id=2a433324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a433324",
  null
  
)

export default component.exports